var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{class:{'container--mobile': _vm.$_breakpoints_mobile},scopedSlots:_vm._u([{key:"component",fn:function(){return [_c('v-col',{staticClass:"container__col"},[_c('History')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }